import React from "react"
import globalGoalsImgs from "../../util/globalGoalsImgUtil"
import { useLanguageStore } from "../../state-management/languageStore"

const GlobalsItem = ({ str }) => {
    const translateFilterLabel = useLanguageStore(
        (state) => state.translateFilterLabel,
    )
    const translatedValue = translateFilterLabel("globalaMal", str)
    const i = str.indexOf(" ")
    const goalNo = parseInt(str.slice(0, i))
    const goalLabel = translatedValue ?? str
    const labelSplitIndex = goalLabel.indexOf(" ")
    const goalName =
        labelSplitIndex >= 0 ? goalLabel.slice(labelSplitIndex + 1) : goalLabel
    const goalImg = globalGoalsImgs[goalNo - 1]
    return (
        <div className="text-md text-primary-500 dark:text-primary-400  rounded p-2 text-center relative">
            <span className="pr-2 font-bold absolute left-2 top-1">
                {goalNo}
            </span>
            <img
                src={goalImg}
                alt="Global goal"
                className="size-16 mx-auto object-contain border-b border-primary-200 dark:border-neutral-800 py-2 mb-1"
            />
            <div className="text-xs">
                <span>{goalName}</span>
            </div>
        </div>
    )
}

export default GlobalsItem
